import React from 'react';

const Loader = () => {
  return (
    <div className="fixed inset-0 bg-gray bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-2xl p-8 flex flex-col items-center space-y-4 shadow-2xl">
        <div className="relative">
          <div className="w-16 h-16 border-4 border-primary-200 rounded-full animate-spin">
            <div className="absolute top-0 left-0 w-4 h-4 bg-primary-500 rounded-full"></div>
          </div>
        </div>
        <p className="text-gray-600 font-medium">Loading...</p>
      </div>
    </div>
  );
};

export default Loader;